import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { styleClasses } from "../../helpers";
import { Button } from "../Buttons/Button";
import "./PaywallBanner.scss";
const CSS_PREFIX = `lav-components-paywall-banner`;
export const PaywallBanner = ({ children, className = "", onClose, style, variant = "pear", }) => (_jsxs("div", { className: classNames(styleClasses(CSS_PREFIX, { variant }), {
        [className]: !!className,
    }), style, children: [children, onClose && (_jsx(Button, { icon: "IconX", size: "small", variant: "plain", className: `${CSS_PREFIX}-close-button`, onClick: onClose }))] }));
